import { Reducer } from "redux";

import { CompareNPIDetailsResponse } from "../models/api/CompareNPI";
import { GetCompareNPIDetailsActionDispatchTypes } from "../constants/CompareNPI";
import { CompareNPIDetailsDispatchTypes } from "../models/dispatchTypes/CompareNPI";

const initialState: CompareNPIDetailsResponse = {
  loading: false,
  response: {
    CompareNpiList: [],
  },
  error: null,
};

const CompareNPIDetailsReducer: Reducer<
  CompareNPIDetailsResponse,
  CompareNPIDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetCompareNPIDetailsActionDispatchTypes.GET_COMPARE_NPI_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default CompareNPIDetailsReducer;
